import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlanService } from '@app/core/services/plan.service';

export const SoloPlanGuard: CanActivateFn = async () => {
  const planService = inject(PlanService);
  const router      = inject(Router);

  await planService.loadOnce();

  if (!planService.isSolo()) {
    return router.createUrlTree(['/moni', 'dashboard']);
  }
  if (!planService.isActive()) {
    return router.createUrlTree(['/acces-refuse']);
  }
  return true;
};
